<template>
  <status-icon
    :status="status"
    :size="size"
    :statuses="statuses"
  ></status-icon>
</template>

<script>
import { ref } from '@vue/composition-api'
import StatusIcon from '@/components/statusIcon/StatusIcon.vue'
import usePaymentsStatusesList from '@/components/lists/paymentsStatuses'

export default {
  components: {
    StatusIcon,
  },
  props: {
    status: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 35,
    },
  },
  setup() {
    const { paymentsStatusesList } = usePaymentsStatusesList()
    const statuses = ref(paymentsStatusesList)

    return {
      statuses,
    }
  },
}
</script>
